import { HeaderFooterState } from '../init';
import { expandAllMenus } from './menus';

export function isGoogleBot(): boolean {
  const userAgent = window?.navigator?.userAgent;
  if (userAgent) {
    return userAgent.toLowerCase().indexOf('googlebot') !== -1;
  }
  return false;
}

export function initGoogleBotLogic(state: HeaderFooterState) {
  if (!state.isDesktop && isGoogleBot()) {
    expandAllMenus();
  }
}
